import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { useAddFeeMutation, useEditFeeMutation } from 'API/order/fees/FeeApi';
import { ISettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { assertDefined } from 'utilities/Assertions';
import { ILineItemProps } from './ILineItemProps';
import { useCallback } from 'react';

export const useLineItemSave = ({ orderId }: ILineItemProps) => {
  const [onAddAsync] = useAddFeeMutation();
  const [onEditAsync] = useEditFeeMutation();

  const onSave = useCallback(
    async ({ settlementSectionId, isNew, settlementStatementItemId, ...newLineItem }: ISettlementItemForm) => {
      if (isNew) {
        const result = await onAddAsync({ ...newLineItem, orderId });
        if (checkForMutationSuccess(result, 'adding fee')) {
          return result.data.settlementStatementItemId;
        }
        return false;
      }

      assertDefined(settlementStatementItemId);
      const result = await onEditAsync({
        ...newLineItem,
        settlementSectionId,
        statementSettlementId: settlementStatementItemId,
        orderId,
      });
      return checkForMutationSuccess(result, 'editing fee');
    },
    [orderId, onAddAsync, onEditAsync]
  );
  return onSave;
};
